<div class="input-counter" [class.input-counter--disabled]="disabled">
  <label [for]="id" class="input-counter__label">
    <div class="input-counter__label__text">
      {{ label }}
    </div>
    <div *ngIf="help" class="input-counter__label__help">
      {{ help }}
    </div>
  </label>

  <div class="input-counter__controls">
    <button
      app-vtmn-play-icon-button
      type="button"
      class="input-counter__button"
      [type]="ctaButtonType.Button"
      [size]="vtmnPlayIconButtonSize.SMALL"
      [variant]="vtmnPlayIconButtonVariant.TERTIARY"
      [disabled]="!canDecrement ? true : null"
      [attr.data-disabled]="!canDecrement ? true : null"
      [attr.aria-label]="'form.input_counter.button.decrement' | translate"
      (click)="decrement()"
      data-test="input-counter-decrement"
    >
      <vtmn-play-icon
        class="input-counter__button__icon"
        [name]="iconType?.SubTract"
      ></vtmn-play-icon>
    </button>

    <input
      class="input-counter__input"
      readonly
      [id]="id"
      [min]="min"
      [max]="max"
      [name]="name"
      [value]="value"
      role="spinbutton"
      [attr.aria-valuenow]="value"
      [attr.aria-valuemin]="min"
      [attr.aria-valuemax]="max"
      data-test="input-counter-value"
      (keydown)="onKeydown($event)"
    />
    <button
      app-vtmn-play-icon-button
      type="button"
      class="input-counter__button"
      [type]="ctaButtonType.Button"
      [size]="vtmnPlayIconButtonSize.SMALL"
      [variant]="vtmnPlayIconButtonVariant.TERTIARY"
      [disabled]="!canIncrement ? true : null"
      [attr.data-disabled]="!canIncrement ? true : null"
      [attr.aria-label]="'form.input_counter.button.increment' | translate"
      (click)="increment()"
      data-test="input-counter-increment"
    >
      <vtmn-play-icon
        class="input-counter__button__icon"
        [name]="iconType?.Add"
      ></vtmn-play-icon>
    </button>
  </div>
</div>
